import { render } from "./LPBoard.vue?vue&type=template&id=73fb85d1&scoped=true"
import script from "./LPBoard.vue?vue&type=script&lang=js"
export * from "./LPBoard.vue?vue&type=script&lang=js"

import "./LPBoard.vue?vue&type=style&index=0&id=73fb85d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fb85d1"]])

export default __exports__